import * as React from "react";
import * as ReactDOM from "react-dom";
import isInFrame from "../Utils/InFrame";

export interface HeaderProps extends React.Props<HeaderControl> {
    environment: string;
    showInFrame?: boolean
}

export class HeaderControl extends React.Component<HeaderProps, any> {
    constructor(props: HeaderProps) {
        super(props);
    }

    public render(): JSX.Element {
        if (!this.props.showInFrame && isInFrame()) {
            return null;
        }
        var environmentDisplay: JSX.Element = null;

        if (this.props.environment != 'prod') {
            environmentDisplay = <span className="environment">{'[ ' + this.props.environment + ' environment ]'}</span>
        }

        return (
            <header>
                <div className="outline">
                    <div className="header">
                        <a className="logo" href="//www.microsoft.com">
                            <svg className="svgicon svgicon-microsoft-color-logo" aria-label="Microsoft">
                                <use xlinkHref="Client/Images/symbol-defs.svg#svgicon-microsoft-color-logo">
                                </use>
                            </svg>
                        </a>
                        {environmentDisplay}
                        {this.props.children}
                    </div>
                </div>
            </header>);
    }
}




// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/HeaderControl.tsx